import { Text } from "@chakra-ui/react";
import { ReactNode } from "react";
import {
  ExternalLinkIcon,
  CalendarIcon,
  LocationIcon,
  SimleFaceIcon,
  TimeIcon,
  PublicIcon,
} from "components";

export interface InfoItemProps {
  imgSrc: any;
  imgAlt: string;
  text: string | ReactNode;
}

export const returnInfoItems = (t: any): InfoItemProps[] => [
  {
    imgSrc: CalendarIcon,
    imgAlt: "calendar icon",
    text: "February 23rd, 2023 | Doors @ 5:30pm",
  },

  // {
  //   imgSrc: TimeIcon,
  //   imgAlt: "time icon",
  //   text: "February 23rd, 2023 | Doors @ 5:30pm",
  // },
  {
    imgSrc: LocationIcon,
    imgAlt: "location-pin icon",
    text: (
      <>
        {t.rich("location", {
          location: (children: any) => (
            <a
              href="https://goo.gl/maps/ULbVVCNWnFDUPy2U8"
              target="_blank"
              rel="noreferrer"
            >
              <Text as="u" color="primary.300">
                {children}
              </Text>
            </a>
          ),
        })}
      </>
    ),
  },

  {
    imgSrc: SimleFaceIcon,
    imgAlt: "simle-face icon",
    text: (
      <Text>
        {t.rich("hostedBy", {
          buZhiDaoParent: (children: any) => (
            <a
              href="https://www.avalanchepark.com/"
              target="_blank"
              rel="noreferrer"
            >
              <span className="text-primary-300 underline">{children}</span>
            </a>
          ),
        })}
      </Text>
    ),
  },
  {
    imgSrc: PublicIcon,
    imgAlt: "public icon",
    text: "Open for Public",
  },
  {
    imgSrc: ExternalLinkIcon,
    imgAlt: "external-link icon",
    text: (
      <Text>
        <span className="mr-5 text-primary-300 underline">
          <a
            href="https://twitter.com/Ed_Balloon"
            target="_blank"
            rel="noreferrer"
          >
            Ed Balloon Twitter
          </a>
        </span>
        <span className="mr-5 text-primary-300 underline">
          <a
            href="https://twitter.com/avalancheavax"
            target="_blank"
            rel="noreferrer"
          >
            Avalanche Twitter
          </a>
        </span>
        <span className="mr-5 text-primary-300 underline">
          <a
            href="https://www.avalanchepark.com/"
            target="_blank"
            rel="noreferrer"
          >
            {t("website")}
          </a>
        </span>
        {/* <span className='mr-5 text-primary-300 underline'>
          <a
            href='https://twitter.com/buzhidao_tw'
            target='_blank'
            rel='noreferrer'
          >
            Twitter
          </a>
        </span> */}
        {/* <span className="mr-5 text-primary-300 underline">
            <a href="#">Discord</a>
          </span> */}
        {/* <span className='mr-5 text-primary-300 underline'>
          <a
            href='https://open.spotify.com/show/4F5tEJAuh0pNiCcTIatWOp?si=f43623d7e80f43c1&nd=1'
            target='_blank'
            rel='noreferrer'
          >
            Podcast
          </a>
        </span> */}
      </Text>
    ),
  },
];
